import React from 'react';
import AttachmentCardComponent, { type AttachmentRow } from './AttachmentCard';
import type { ContextItem } from '../../store/chatStore';

import { useTranslation } from 'react-i18next';

type VulnerabilityAttachment = {
  id?: string;
  assetId?: string;
  assetType?: string;
  provider?: string;
  hasVendorFix?: boolean;
};

export const VulnerabilityContext: React.FC<{
  item: ContextItem;
  onRemove: () => void;
}> = ({ item, onRemove }) => {
  const { t } = useTranslation('pleri/chat');
  const vuln = item.attachmentMetaData as VulnerabilityAttachment | undefined;
  const rows: Array<AttachmentRow> = [];

  if (vuln?.assetType) {
    rows.push({ label: t('assetType'), value: vuln.assetType });
  }

  if (typeof vuln?.hasVendorFix === 'boolean') {
    rows.push({
      label: t('hasVendorFix'),
      value: vuln.hasVendorFix ? 'Yes' : 'No',
    });
  }

  return (
    <AttachmentCardComponent
      icon={item.icon}
      title={vuln?.id || t('common:vulnerability')}
      rows={
        rows.length
          ? rows
          : item.display
            ? [
                {
                  label: t('common:vulnerability'),
                  value: String(item.display),
                },
              ]
            : []
      }
      onRemove={onRemove}
      removeAriaLabel="Remove vulnerability context"
    />
  );
};

export default VulnerabilityContext;
